export default {
  init() {
    $('#wc_checkout_add_ons textarea').attr( 'placeholder', 'Your message (max 120 characters)' );
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/checkout.js